export default {
  namespaced: true,
  state: () => ({
    show: false,
    text: '',
    color: 'success',
    timeout: 3000
  }),
  getters: {
    show: state => state.show,
    text: state => state.text,
    color: state => state.color,
    timeout: state => state.timeout
  },
  mutations: {
    setShow: (state, show) => { state.show = show },
    setText: (state, text) => { state.text = text },
    setColor: (state, color) => { state.color = color },
    setTimeout: (state, timeout) => { state.timeout = timeout }
  },
  actions: {
    showSnackbar({ commit }, payload) {
      // Set default values if not provided
      const text = typeof payload === 'string' ? payload : payload.text;
      const color = payload.color || 'success';
      const timeout = payload.timeout || 3000;
      
      commit('setText', text);
      commit('setColor', color);
      commit('setTimeout', timeout);
      commit('setShow', true);
    },
    hideSnackbar({ commit }) {
      commit('setShow', false);
    }
  }
}
